import React from 'react';

function HelpPage() {
  return (
    <div className="App">
      <h1>HelpPage</h1>
    </div>
  );
}

export default HelpPage;
